import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PriceCalculator from './BookingForm';
import '../styles/floating-calculator.css';

const FloatingCalculator = () => {
    console.log('=== FloatingCalculator Component ===');
    console.log('1. Component rendering');
    
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        console.log('2. FloatingCalculator mounted');
        console.log('3. Current state:', { isOpen });
        
        // Debug styly
        const button = document.querySelector('.floating-calculator-button');
        if (button) {
            console.log('4. Button styles:', window.getComputedStyle(button));
        }
    }, [isOpen]);

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        className="floating-calculator-widget"
                    >
                        <div className="widget-header">
                            <h3>Kalkulátor ceny</h3>
                            <button 
                                onClick={() => setIsOpen(false)}
                                className="close-button"
                            >
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2">
                                    <path d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="widget-content">
                            <PriceCalculator onComplete={() => setIsOpen(false)} />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setIsOpen(true)}
                className="floating-calculator-button"
            >
                <svg 
                    className="calculator-icon" 
                    viewBox="0 0 24 24" 
                    width="24" 
                    height="24" 
                    stroke="currentColor" 
                    strokeWidth="2"
                    fill="none"
                >
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                    <line x1="8" y1="7" x2="16" y2="7" />
                    <line x1="8" y1="11" x2="16" y2="11" />
                    <line x1="8" y1="15" x2="16" y2="15" />
                </svg>
                <span>Kalkulátor ceny</span>
            </motion.button>
        </>
    );
};

export default FloatingCalculator; 